import moment from "moment";
import { LoadState } from "../../../constants/enums";
import {  getUniqueId } from "../../../helpers";
import { IFileUpload } from "../../../features/FileUpload/components/FileUpload.type";

export interface IAccountingPaymentAccountsRecievableState {
  list: IPaymentRecord[];
  listLoading: LoadState;
  totalRecords: number;
  data: ISinglePaymentRecord;
  loading: LoadState;
  error: string | null;
}

export interface IPaymentRecord {
  accn_invoice_payment_accounts_receivable_id?: any;
  invoice_id: number | null;
  customerId?: any;
  payment_id: number | null;
  entry_type: string | null;
  payment_number: string | null;
  gl_accounts: string | null;
  invoice_payment_gl_account_name: string | null;
  date: string | null;
  receipt_id: string | null;
  code: string | null;
  name: string | null;
  payment_for: string | null;
  policy_id: string | null;
  policy_number: string | null;
  default_tax_region: string | null;
  payment_type: string | null;
  payment_currency: string | null;
  payment_amount: string | null;
  service_fee: string | null;
  payment_method: string | null;
  bank: string | null;
  reference_info: string | null;
  status: string;
  broker_code: string | null;
  payment_frequency: string | null;
  paid_to: string | null;
  vendor: string | null;
  cheque_id: string | null;
  agency_or_direct_bill: string | null;
  reconciled?: string | null;
  reconciled_date?: string | null;
  file_upload: IFileUpload[] | null;
  instructions: string | null;
  is_record_duplicate?: boolean;
}
export interface ISinglePaymentRecord extends IPaymentRecord {
  batch_id: string | null;
  invoice_details: IInvoiceDetails[];
  total_paid: string | null;
  amount_excess: string | null;
  total_due: string | null;
  is_mannual_invoice: boolean;
}

export interface IInvoiceDetails {
  key: string;
  invoice_number: string | null;
  invoice_id: string | null;
  date: string | null;
  amount_due: string | null;
  payment_paid: string | null;
  total_due_dollar: string | null;
  fromCustomer: boolean;
  financed_by?: string | null;
}

export const initialAccountingPaymentAccountsRecievableState: IAccountingPaymentAccountsRecievableState =
  {
    list: [],
    totalRecords: 0,
    listLoading: LoadState.NotLoaded,
    data: {
      invoice_id: null,
      payment_id: null,
      payment_number: null,
      entry_type: null,
      gl_accounts: null,
      invoice_payment_gl_account_name: null,
      date: moment().format("YYYY-MM-DD"),
      batch_id: null,
      receipt_id: null,
      code: null,
      name: null,
      payment_for: "Customer",
      policy_id: null,
      policy_number: null,
      default_tax_region: "ON",
      payment_type: "Payment",
      payment_currency: "CAD",
      payment_amount: null,
      service_fee: null,
      payment_method: null,
      bank: null,
      reference_info: null,
      agency_or_direct_bill: null,
      status: "DRAFT",
      file_upload: null,
      invoice_details: [
        {
          key: getUniqueId(),
          invoice_number: null,
          invoice_id: null,
          date: null,
          amount_due: null,
          payment_paid: null,
          total_due_dollar: null,
          fromCustomer: false,
        },
      ],
      total_due: null,
      is_mannual_invoice: false,
      amount_excess: null,
      total_paid: null,
      broker_code: null,
      paid_to: "Customer",
      payment_frequency: "Single",
      vendor: null,
      cheque_id: null,
      instructions: null,
      is_record_duplicate: false,
    },
    loading: LoadState.NotLoaded,
    error: null,
  };
